export const SAVE_IMPORT_WIZARD_FILE = 'SAVE_IMPORT_WIZARD_FILE';
export type SAVE_IMPORT_WIZARD_FILE = typeof SAVE_IMPORT_WIZARD_FILE;

export interface SaveImportWizardFile {
    type: SAVE_IMPORT_WIZARD_FILE;
    file: File | null;
}

export function saveImportWizardFileAction(file: File | null): SaveImportWizardFile {
    return {
        type: SAVE_IMPORT_WIZARD_FILE,
        file
    };
}
